/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.isInKio = this.dataset.inKio == 'true';

      this.currentHandle = this.dataset.currentHandle;

      this.addEventListener('change', this.handleVariantChange.bind(this));
      document.addEventListener(`on:variant:change-${this.data.product.id}`, this.handleSyncChange.bind(this));
    }


    connectedCallback() {


      setTimeout(() => {
        this.variant = this.getSelectedVariant();

        const isCurrentPage = this.currentHandle == this.data.product.handle;

        // if (!this.isInKio && this.data.product.variants.length > 1) {
        //   this.handlePreselectedVariant();
        // }
        if (this.isInKio && this.data.product.variants.length > 1) {
          this.handleKioPreselectedVariant();
        }


        this.updateAvailability();
      }, 1000);
    }


      //  for product in kio  
        handleKioPreselectedVariant() {
          const kioVariantId = Number(this.dataset.kioVariantId);
          if (!kioVariantId) return;
          const targetVariant = this.data.product.variants.find(
            variant => variant.id === kioVariantId
          );
          if (targetVariant) {
            this.handleInitialVariantSelected(targetVariant);
          }
        }


        // handlePreselectedVariant() {
        //   if (this.isInKio) return;   // Kio ma nahi karvu hoy to

        //   // Pehla available (orderable + viewable) variant find karo
        //   let targetVariant = null;

        //   for (const variant of this.data.product.variants) {
        //     const formatted = this.data.formatted[variant.id];
            
        //     if (formatted && 
        //         variant.metafields?.stroetmann?.orderable?.value === 'J' && 
        //         variant.metafields?.stroetmann?.viewable?.value === 'J') {
              
        //       targetVariant = variant;
        //       break;                    // ← Pehla available male etle stop
        //     }
        //   }

        //   // Jo koi available variant male ane currently selected thi alag hoy to select karo
        //   if (targetVariant && targetVariant.id !== this.variant?.id) {
        //     this.handleInitialVariantSelected(targetVariant);
        //   }
        // }

    handleInitialVariantSelected(variant) {

      if (!variant) return;

      this.variant = variant;

      const customSelect = this.querySelector('custom-select');
      if (!customSelect) return;
      const option = this.querySelector(`.custom-select__option[data-value="${this.variant.title}"]`);
      customSelect.selectOption(option);
      // const productCard = this.closest('product-card');
      // if (productCard) {
      //   const anker = productCard.querySelector('.js-prod-link');
      //   const searchParams = new URLSearchParams(anker.getAttribute('href'));
      //   searchParams.set('variant', this.variant.id);
      //   anker.setAttribute('href', `${this.dataset.url}?${searchParams.toString()}`);
      // }

    }

    handleSyncChange({ detail }) {
      const select = this.querySelector('custom-select');
      if (!select) return;
      const selectedOption = select.selectedOption;
      if (select.options && this.variant.id != detail.variant.id) {
        const option = [...select.options].find((option) => option.dataset.value == detail.variant.title);
        select.selectOption(option);
      }
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {

      this.variant = this.getSelectedVariant();

      if (this.variant) {
        this.setAttribute('data-variant-id', this.variant.id);
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updatePrice();
      this.updateAvailability();
      this.updateDiscountRibbons();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateInventoryText();
      this.updateAtcErrorEle();
      VariantPicker.updateLabelText(evt);

      document.dispatchEvent(
        new CustomEvent(`on:variant:change-${this.data.product.id}`, {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product,
            formatted: this.data.formatted[this.variant.id],
          },
        })
      );
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;
      const selectedOptions = this.getSelectedOptions();

      if (!this.variant) {
        currVariant = { options: selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
      if (!this.mediaGallery) return;

      const variantMedia = this.mediaGallery.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`);
      this.mediaGallery.setActiveMedia(variantMedia, true, true);
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates add to cart error message element.
     */
    updateAtcErrorEle() {
      if (!this.variant) return;

      const productCard = this.closest('product-card') || this.closest('.cc-main-product');
      if (!productCard) return;

      const errorEle = productCard.querySelectorAll('.atc-error');
      if(!errorEle.length) return;

      errorEle.forEach(div => div.remove());
    }

    /**
     * Updates the inventory quantity.
     */
    updateInventoryText() {
      if (!this.variant) return;

      const productCard = this.closest('product-card') || this.closest('.cc-main-product');
      if (!productCard) return;

      const allInventoryDivs = productCard.querySelectorAll('[data-stock-inventory]');
      const qtyEle = productCard.querySelector('quantity-input input');
      const maxInventoryInput = productCard.querySelector('input[name="properties[_max_inventory]"]');

      const currentVariantId = this.variant.id;
      let quantity = 0;
      
      // Hide all inventory divs first
      allInventoryDivs.forEach(div => div.classList.add(`hidden`));

      // Show only the matching variant's inventory
      const activeInventory = productCard.querySelector(`[data-stock-inventory][data-variant-id="${currentVariantId}"]`);
      if (activeInventory) {
        quantity = parseInt(activeInventory.dataset?.inventoryQty || 0);
        activeInventory.classList.remove(`hidden`);
      }

      console.log(`Inventory for variantId (${currentVariantId}) => Qty: ${quantity}`);

      // === Update Quantity Input & Max Inventory ===
      if (qtyEle) {
        const allowMoreThanMaxQty = productCard.querySelector('quantity-input')?.dataset.allowMoreThanMaxQty === 'false';

        qtyEle.setAttribute('data-available-qty', quantity >= 0 ? quantity : '');

        if (allowMoreThanMaxQty) {
          if (quantity >= 0) {
            qtyEle.max = quantity;
            qtyEle.disabled = (quantity === 0);
          } else {
            qtyEle.removeAttribute('max');
            qtyEle.disabled = false;
          }
        }
      }

      if (maxInventoryInput) {
        maxInventoryInput.value = quantity >= 0 ? quantity : '';
      }
    }


    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');

      //for compare modal
      if(this.closest(`.compare-container`)){
        let productId = this.section.dataset.productId;
        this.price = this.closest(`.compare-container`).querySelector(`.product-info__price[data-product-id="${productId}"] > .price`);
      }

      //console.log(`this.data >>`,this.data)

      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        // const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        if (this.data.formatted[this.variant.id].portionPrice) {
          var portionHtml = new DOMParser().parseFromString(this.data.formatted[this.variant.id].portionPrice, 'text/html');
          const valueEl = this.price.querySelector('[data-portion-price]');
          if (valueEl) {
            // @ts-ignore
            valueEl.innerHTML = portionHtml.querySelector('[data-portion-price]').innerHTML;
          }
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        // unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle('price--on-sale', this.variant.compare_at_price > this.variant.price);
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the discount ribbons.
     */
    updateDiscountRibbons() {
      const productCard = this.closest('product-card') || this.closest('.cc-main-product');
      let compareDiscount;
      if(productCard){
        compareDiscount = productCard.querySelector(`compare-discount`);

        //update assortment-interact component variant id attribute
        if(productCard.querySelector(`assortment-interact`) && this.variant){
          productCard.querySelector(`assortment-interact`).setAttribute(`data-variant-id`,this.variant.id);
        }
      }

      if(!compareDiscount) return;

      const price = this.data?.formatted[this.variant.id]?.variant_price;
      const compareAtPrice = this.data?.formatted[this.variant.id]?.variant_compare_at_price;

      if(price && compareAtPrice && compareAtPrice > price){
        compareDiscount.setAttribute(`data-compare-price`,compareAtPrice);
        compareDiscount.setAttribute(`data-price`,price);

        //update inner HTML
        const priceDifference = compareAtPrice - price;
        const discountPercentage = (priceDifference * 100) / compareAtPrice;

        let compareDiscountLabel;
        const compareDiscountText = compareDiscount.getAttribute(`data-string`);
        
        if(compareDiscountText){
          compareDiscountLabel = compareDiscountText.replace(`[amount]!`,`${Math.round(discountPercentage)} %`);
        }else{
          compareDiscountLabel = `Sparen Sie ${Math.round(discountPercentage)} %`;
        }

        if(compareDiscountLabel){
          compareDiscount.textContent = compareDiscountLabel;
          compareDiscount.removeAttribute(`hidden`);
        }
      }else{
        compareDiscount.textContent = ``;
        compareDiscount.setAttribute(`hidden`,``);
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.js-product-barcode');
      if (this.barcode === null) return;

      const variantBarcode = this.data.formatted[this.variant.id].sku || this.data.formatted[this.variant.id].barcode;
      this.barcode.innerHTML = variantBarcode;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      let userKey = '';
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('key')) {
        userKey = `&key=${searchParams.get('key')}`;
      }
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}${userKey}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        const quantityInputEl = form.querySelector('quantity-input');
        if (quantityInputEl) {
          quantityInputEl.dataset.variantId = this.variant.id;
        }
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked')?.value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find((v) => v.options.every((val, index) => val === selectedOptions[index]));
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
